module.exports = __webpack_public_path__ + "img/thumbnail_Reindeer_m_albino.7e1bb29c.png";